import * as api from "../../api/general"
import { getConfig } from "../../config/index"
import { getSourceTrackingInfo } from "../util/generalUtil"
import { LeadMagnetFormStateType } from "../components/landing-page/new/components/lead-capture/lead-magnet/LeadMagnetForm"
import { EnquiryFormStateType } from "../components/landing-page/new/components/lead-capture/enquiry-form/EnquiryForm"

export const leadMagnet = async (formState: LeadMagnetFormStateType, eventName: string) => {
  return api.post(`${getConfig().baseUrl}/wp-json/social-supermarket/v1/lead-capture/lead-magnet`, {
    ...formState,
    eventName,
    utm: { ...getSourceTrackingInfo() },
  })
}

export const subscribe = async (email: string, forIndividuals: boolean, forCompanies: boolean) => {
  return api.post(`${getConfig().baseUrl}/wp-json/social-supermarket/v1/lead-capture/subscribe`, {
    email,
    forIndividuals,
    forCompanies,
    utm: { ...getSourceTrackingInfo() },
  })
}

export const enquiry = async (
  formState: EnquiryFormStateType,
  source: "Inbound Enquiry" | "Inbound Enquiry - Gifting" | "Inbound Enquiry - General",
  isMql: boolean,
  to: string
) => {
  return api.post(`${getConfig().baseUrl}/wp-json/social-supermarket/v1/lead-capture/enquiry`, {
    ...formState,
    utm: { ...getSourceTrackingInfo() },
    source,
    isMql,
    to,
  })
}
